import _ from 'lodash'
import { createSelector } from '@reduxjs/toolkit'
import { State } from '../types'
import { ReceivementState, SalesBatchesState } from './ReceivementTypes'

const selectFeature = (state: State) => state.receivement

export const selectOnlyDivergents = createSelector(
  selectFeature,
  (state: ReceivementState) => state.overviewFilters.onlyDivergents,
)

export const selectProductDescription = createSelector(
  selectFeature,
  (state: ReceivementState) => state.overviewFilters.productDescription,
)

export const selectSortBy = createSelector(
  selectFeature,
  (state: ReceivementState) => state.overviewFilters.sortBy,
)

export const selectOverviewFilters = createSelector(
  selectFeature,
  (state: ReceivementState) => state.overviewFilters,
)

export const selectOverview = createSelector(
  selectFeature,
  (state: ReceivementState) => state.overview,
)

export const selectSalesOverview = createSelector(
  selectFeature,
  (state: ReceivementState) => state.salesOverview,
)

export const selectSalesAwaitStatus = createSelector(
  selectFeature,
  (state: ReceivementState) => state.awaitStatus,
)

export const selectSalesHasProducts = createSelector(
  selectFeature,
  (state: ReceivementState) => (state.batchesStateByBatchItemOrderIds ? Object.keys(state.batchesStateByBatchItemOrderIds).length > 0 : false),
)

export const selectSalesHasErrors = createSelector(
  selectFeature,
  (state: ReceivementState) => (state.batchErrorIds.length > 0),
)

export const selectFirstObservationPosition = createSelector(
  selectFeature,
  (state: ReceivementState) => {
    const positionToGo = Object.values(state.observationsPositionByModelId)
      .filter((position) => !Number.isNaN(position))
      .sort((a, b) => a - b)
    return _.first(positionToGo) || Number.NaN
  },
)

export const selectObservationsPositionByModelId = createSelector(
  selectFeature,
  (state: ReceivementState) => (state.observationsPositionByModelId),
)

export const selectBatches = createSelector(
  selectFeature,
  (state: ReceivementState) => (state.batches),
)

export const selectDirectGondolaPrintLimit = createSelector(
  selectFeature,
  (state: ReceivementState) => (state.directGondolaPrintLimit),
)

export const selectBatchesStateByIds = (batchIds: string[]) => (state: State): SalesBatchesState =>
  batchIds.reduce<SalesBatchesState>((acc, id) => {
    const batch = state.receivement.batchesStateByBatchItemOrderIds[id]
    if (batch) acc[id] = batch
    return acc
  }, {})

export const selectArStockDaysSumByProduct = (modelId: number, idReceivementAuthorization: number) =>
  (state: State): number =>
    Object.values(state.receivement.batchesStateByBatchItemOrderIds).reduce((sum, b) => {
      if (b.modelId === modelId && b.idReceivementAuthorization === idReceivementAuthorization) {
        return sum + (b.stockDays || 0)
      }
      return sum
    }, 0)

export const selectUserAssigned = createSelector(
  selectFeature,
  (state: ReceivementState) => state.userAssigned,
)

export const selectReceivementLoading = createSelector(
  selectFeature,
  (state: ReceivementState) => state.loading,
)

export const selectIsOneNotReady = createSelector(
  (state: State) => state.receivement.batchesStateByBatchItemOrderIds,
  (batchesState) => Object.values(batchesState).some(
    (batch) => batch.acceptedQuantity === null || batch.acceptDamage === undefined,
  ),
)
